// Sprawdzanie kompletnosci danych firmy (zakladka "Dane firmy").
// Te pola sa wstawiane do umow jako zmienne {{organizationName}}, {{organizationNIP}} itd. —
// gdy sa puste, wygenerowana umowa ma puste miejsca, o czym klient moze sie nie zorientowac.

const isFilled = (v) => typeof v === 'string' ? v.trim().length > 0 : Boolean(v);

/**
 * Zwraca liste brakujacych kluczowych pol danych firmy.
 * @param {object|null} settings - obiekt ustawien (z GET /api/contract-settings lub stan formularza)
 * @returns {{ key: string, label: string }[]}
 */
export function getMissingCompanyFields(settings) {
  const s = settings || {};
  const missing = [];

  if (!isFilled(s.company_name)) {
    missing.push({ key: 'company_name', label: 'Nazwa firmy' });
  }

  const hasAddress = isFilled(s.company_address) ||
    (isFilled(s.company_street) && isFilled(s.company_postal_code) && isFilled(s.company_city));
  if (!hasAddress) {
    missing.push({ key: 'company_address', label: 'Adres firmy' });
  }

  if (!isFilled(s.company_nip)) {
    missing.push({ key: 'company_nip', label: 'NIP' });
  }

  if (!isFilled(s.company_phone) && !isFilled(s.company_email)) {
    missing.push({ key: 'company_contact', label: 'Telefon lub e-mail firmy' });
  }

  return missing;
}
